import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpErrorResponse,
} from '@angular/common/http';

import { catchError, switchMap, throwError } from 'rxjs';

import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const auth = inject(AuthService);

  const token = auth.getAccessToken();

  const authReq = token
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      })
    : req;

  const hasSession = !!(token || auth.getRefreshToken());
  const isAuthEndpoint =
    req.url.includes('/Auth/Logout') ||
    req.url.includes('/Auth/Refresh') ||
    req.url.includes('/Auth/Login') ||
    req.url.includes('/Auth/Register');

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // Tenta refresh apenas em caso de 401 em requests que não sejam endpoints de logout/refresh/login/register
      if (error.status === 401 && auth.getRefreshToken() && !isAuthEndpoint) {
        return auth.refresh().pipe(
          switchMap(() => {
            const newToken = auth.getAccessToken();

            const retryReq = req.clone({
              setHeaders: {
                Authorization: `Bearer ${newToken}`,
              },
            });

            return next(retryReq);
          }),

          catchError((refreshError) => {
            if (hasSession) {
              auth.clearSession();
            }
            return throwError(() => refreshError);
          }),
        );
      }

      // Token inválido, sessão revogada ou acesso negado
      if (error.status === 401 && hasSession) {
        auth.clearSession();
      }

      return throwError(() => error);
    }),
  );
};
